/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from 'react';
import MainContainer, { GlobalStyles } from '../components/MainContainer';
import Footer from '../components/Footer';
import '../styles/Home.css';
import api from '../api';
import { useParams } from 'react-router-dom';
import StylesContext from '../context/StylesContext';
import VideoContext from '../context/VideoContext';
import VideoPlayer from '../components/VideoPlayer';
import MainLogoContainer from '../components/MainLogoContainer';
import StyledContainer from '../components/StyledContainer';
import TopText from '../components/TopText';
import StyledImage from '../components/StyleImage';
import useAudioDescBtn from '../hooks/useAudioDescBtn';
import useSessionStorage from '../hooks/useSessionStorage';
import ButtonAudioDesc from '../components/ButtonAudioDesc';
import ButtonLibras from '../components/ButtonLibras';
import CategoriesListVocal from './CategoriesListVocal';
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import ChartVocalInterface from './ChartVocalInteface';
import { useLanguage, useNoPCD } from "../hooks/languageService";
import ButtonLang from '../components/ButtonLang';

function Home() {
  const { styles, setStyles } = useContext(StylesContext);
  const { selectedLanguage, setLanguage } = useLanguage();
  const langId = selectedLanguage.split('-')[0];
  const langEndpoint = langId.includes('pt') ? '' : `-${langId}`;
  const urlId = styles?.urlId + langEndpoint;
  const { setSrcId, isVideo, videoSrc } = useContext(VideoContext);
  const { isVocalInterface, isChart, setIsAdButtonClicked } = useContext(VocalInterfaceContext);
  const handleAudio = useAudioDescBtn({ urlId });
  const { saveStylesToSessionStorage } = useSessionStorage();
  const { menu } = useParams<{ menu: string }>();
  const [mainContainerStyles, setMainContainerStyles] = useState<string>('home_main_container');
  const { setNoPCD  } = useNoPCD();
  

  const handleClick = () => {
    handleAudio(styles?.urlId);
    setLanguage('pt-BR');
    setNoPCD(false);
    setIsAdButtonClicked(true);
  };

  useEffect(() => {
    const getStyles = async () => {
      try {
        const { data } = await api.get(`menu_styles/${menu}`);
        setStyles(data);
        saveStylesToSessionStorage(data);
        setSrcId(data.urlId);
      } catch (error: any) {
        console.error(error.message);
      }
    }
    getStyles();
  }, [menu]);

  useEffect(() => {
    if (isVocalInterface && !isChart) {
      setMainContainerStyles('categories_list_page');
      return;
    }
    if (isChart && !isVocalInterface) {
      setMainContainerStyles('chart_main_container');
      return;
    };
  }, [isChart, isVocalInterface]);

  return (
    <MainContainer className={mainContainerStyles} $backgroundColor={styles?.bgColor}>
      <GlobalStyles $backgroundColor={styles?.bgColor}/>
      {(!isVideo && !isVocalInterface && !isChart) && (
        <>
          <StyledContainer className='home_page_container'>
            <StyledContainer className='Logo_client_home_wrapper' onClick={handleClick}>
              <TopText />
              <MainLogoContainer wrapperClass='logo_home_wrapper' logoClass='logo_home' />
            </StyledContainer>
            <StyledContainer className='buttons_container'>
              <StyledContainer id='button_langs' className='button_wrapper'>
                <ButtonLang
                  fillCircleBtn={styles.btnBgColor}
                  circleBorderColor={styles.btnCircleColor}
                  fillSymbolBtn={styles.btnColor}
                />
              </StyledContainer>
              <StyledContainer
                id='button_audioDesc'
                className='button_wrapper'
                onClick={handleClick}
              >
                <ButtonAudioDesc
                  fillCircleBtn={styles.btnBgColor}
                  circleBorderColor={styles.btnCircleColor}
                  fillSymbolBtn={styles.btnColor}
                />
              </StyledContainer>
              <StyledContainer id='button_libras' className='button_wrapper'>
                <ButtonLibras
                  fillCircleBtn={styles.btnBgColor}
                  circleBorderColor={styles.btnCircleColor}
                  fillSymbolBtn={styles.btnColor}
                />
              </StyledContainer>
            </StyledContainer>
          </StyledContainer>
          <Footer $footerLogoColor={styles.footerColor} />
        </>
      )
      }
      {isVideo && (
        <>
          <StyledContainer className='logo_video_player'>
            <StyledImage src={styles?.logoImg} />
          </StyledContainer>
          <StyledContainer className='video_player_home_wrapper'>
            <VideoPlayer src={videoSrc} autoPlay={true} controls={true} className='home_videoplayer' />
          </StyledContainer>
        </>
      )
      }
      {
        (isVocalInterface && !isChart) && (
          <>
            <CategoriesListVocal />
          </>
        )
      }
      {
        (isChart && !isVocalInterface) && (
          <ChartVocalInterface />
        )
      }
    </MainContainer>
  )
}

export default Home;
